import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Company from '@/views/Company.vue';
import Interview from '@/views/Interview.vue';
import ThankYou from '@/views/ThankYou.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/interview/:qid',
    name: 'Interview',
    component: Interview,
    props: true,
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: ThankYou,
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
